export const EVENTS = {
  ACCOUNT_DELETION_CONFIRMED: 'account_deletion_confirmed',
  ACCOUNT_DELETION_INITIATED: 'account_deletion_initiated',
  API_ERROR_OCCURRED: 'api_error_occurred',
  AI_COACH_BUTTON_VIEWED: 'ai_coach_button_viewed',
  AI_COACH_CHARACTER_LIMIT_HIT: 'ai_coach_character_limit_hit',
  AI_COACH_CLOSED: 'ai_coach_closed',
  AI_COACH_ERROR: 'ai_coach_error',
  AI_COACH_LIMIT_MODAL_DISMISSED: 'ai_coach_limit_modal_dismissed',
  AI_COACH_LIMIT_MODAL_DISPLAYED: 'ai_coach_limit_modal_displayed',
  AI_COACH_LIMIT_NEW_ANALYSIS_CLICKED: 'ai_coach_limit_new_analysis_clicked',
  AI_COACH_LIMIT_REACHED: 'ai_coach_limit_reached',
  AI_COACH_LIMIT_UPGRADE_CLICKED: 'ai_coach_limit_upgrade_clicked',
  AI_COACH_LIMIT_WARNING_SHOWN: 'ai_coach_limit_warning_shown',
  AI_COACH_MESSAGE_RECEIVED: 'ai_coach_message_received',
  AI_COACH_MESSAGE_SENT: 'ai_coach_message_sent',
  AI_COACH_OPENED: 'ai_coach_opened',
  AI_COACH_POPUP_DISMISSED: 'ai_coach_popup_dismissed',
  AI_COACH_POPUP_DISPLAYED: 'ai_coach_popup_displayed',
  AI_COACH_RETRY_CLICKED: 'ai_coach_retry_clicked',
  AI_COACH_SESSION_ENDED: 'ai_coach_session_ended',
  AI_COACH_SESSION_STARTED: 'ai_coach_session_started',
  CL_ANALYSIS_ABANDONED: 'cl_analysis_abandoned',
  CL_ANALYSIS_CL_UPLOADED: 'cl_analysis_cl_uploaded',
  CL_ANALYSIS_COMPLETED: 'cl_analysis_completed',
  CL_ANALYSIS_CV_UPLOADED: 'cl_analysis_cv_uploaded',
  CL_ANALYSIS_DIMENSION_EXPANDED: 'cl_analysis_dimension_expanded',
  CL_ANALYSIS_FAILED: 'cl_analysis_failed',
  CL_ANALYSIS_JD_INPUT_METHOD_SELECTED: 'cl_analysis_jd_input_method_selected',
  CL_ANALYSIS_JD_LINK_PARSED: 'cl_analysis_jd_link_parsed',
  CL_ANALYSIS_JD_LINK_SUBMITTED: 'cl_analysis_jd_link_submitted',
  CL_ANALYSIS_JD_PARSED: 'cl_analysis_jd_parsed',
  CL_ANALYSIS_JD_PASTED: 'cl_analysis_jd_pasted',
  CL_ANALYSIS_LOADING_CANCELLED: 'cl_analysis_loading_cancelled',
  CL_ANALYSIS_LOADING_STARTED: 'cl_analysis_loading_started',
  CL_ANALYSIS_RECOMMENDATIONS_TOGGLED: 'cl_analysis_recommendations_toggled',
  CL_ANALYSIS_RESTARTED: 'cl_analysis_restarted',
  CL_ANALYSIS_SETUP_VIEWED: 'cl_analysis_setup_viewed',
  CL_ANALYSIS_SUBMITTED: 'cl_analysis_submitted',
  CL_GENERATION_ABANDONED: 'cl_generation_abandoned',
  CL_GENERATION_COMPLETED: 'cl_generation_completed',
  CL_GENERATION_CV_UPLOADED: 'cl_generation_cv_uploaded',
  CL_GENERATION_DOWNLOADED: 'cl_generation_downloaded',
  CL_GENERATION_EDITED: 'cl_generation_edited',
  CL_GENERATION_FAILED: 'cl_generation_failed',
  CL_GENERATION_PREVIEWED: 'cl_generation_previewed',
  CL_GENERATION_JD_INPUT_METHOD_SELECTED: 'cl_generation_jd_input_method_selected',
  CL_GENERATION_JD_LINK_PARSED: 'cl_generation_jd_link_parsed',
  CL_GENERATION_JD_LINK_SUBMITTED: 'cl_generation_jd_link_submitted',
  CL_GENERATION_JD_PASTED: 'cl_generation_jd_pasted',
  CL_GENERATION_LOADING_CANCELLED: 'cl_generation_loading_cancelled',
  CL_GENERATION_LOADING_STARTED: 'cl_generation_loading_started',
  CL_GENERATION_REGENERATED: 'cl_generation_regenerated',
  CL_GENERATION_SETUP_VIEWED: 'cl_generation_setup_viewed',
  CL_GENERATION_SUBMITTED: 'cl_generation_submitted',
  CV_ANALYSIS_ABANDONED: 'cv_analysis_abandoned',
  CV_ANALYSIS_COMPLETED: 'cv_analysis_completed',
  CV_ANALYSIS_CV_UPLOADED: 'cv_analysis_cv_uploaded',
  CV_ANALYSIS_DIMENSION_EXPANDED: 'cv_analysis_dimension_expanded',
  CV_ANALYSIS_FAILED: 'cv_analysis_failed',
  CV_ANALYSIS_JD_INPUT_METHOD_SELECTED: 'cv_analysis_jd_input_method_selected',
  CV_ANALYSIS_JD_LINK_PARSED: 'cv_analysis_jd_link_parsed',
  CV_ANALYSIS_JD_LINK_SUBMITTED: 'cv_analysis_jd_link_submitted',
  CV_ANALYSIS_JD_PARSED: 'cv_analysis_jd_parsed',
  CV_ANALYSIS_JD_PASTED: 'cv_analysis_jd_pasted',
  CV_ANALYSIS_LOADING_CANCELLED: 'cv_analysis_loading_cancelled',
  CV_ANALYSIS_LOADING_STARTED: 'cv_analysis_loading_started',
  CV_ANALYSIS_RECOMMENDATIONS_TOGGLED: 'cv_analysis_recommendations_toggled',
  CV_ANALYSIS_RESTARTED: 'cv_analysis_restarted',
  CV_ANALYSIS_SETUP_VIEWED: 'cv_analysis_setup_viewed',
  CV_ANALYSIS_SUBMITTED: 'cv_analysis_submitted',
  DASHBOARD_FIRST_VIEWED: 'dashboard_first_viewed',
  DASHBOARD_STAT_CARD_CLICKED: 'dashboard_stat_card_clicked',
  DASHBOARD_VIEWED: 'dashboard_viewed',
  DOWNGRADE_BUTTON_CLICKED: 'downgrade_button_clicked',
  DOWNGRADE_CONFIRMED: 'downgrade_confirmed',
  DOWNGRADE_MODAL_CLOSED: 'downgrade_modal_closed',
  DOWNGRADE_MODAL_VIEWED: 'downgrade_modal_viewed',
  ERROR_DISPLAYED: 'error_displayed',
  FILE_UPLOAD_FAILED: 'file_upload_failed',
  HELP_MESSAGE_SUBMITTED: 'help_message_submitted',
  HELP_WIDGET_OPENED: 'help_widget_opened',
  HISTORY_FILTER_APPLIED: 'history_filter_applied',
  HISTORY_RECORD_ARCHIVED: 'history_record_archived',
  HISTORY_RECORD_UNARCHIVED: 'history_record_unarchived',
  HISTORY_PAGE_VIEWED: 'history_page_viewed',
  HISTORY_RECORD_VIEWED: 'history_record_viewed',
  INTERVIEW_ANALYSIS_COMPLETED: 'interview_analysis_completed',
  INTERVIEW_ANALYSIS_FAILED: 'interview_analysis_failed',
  INTERVIEW_ANALYSIS_LOADING_STARTED: 'interview_analysis_loading_started',
  INTERVIEW_DEVICE_TOGGLED: 'interview_device_toggled',
  INTERVIEW_ENDED_BY_TIMEOUT: 'interview_ended_by_timeout',
  INTERVIEW_ENDED_BY_USER: 'interview_ended_by_user',
  INTERVIEW_ENDED_EARLY_CONFIRMED: 'interview_ended_early_confirmed',
  INTERVIEW_MOMENT_TIER_EXPANDED: 'interview_moment_tier_expanded',
  INTERVIEW_PILLAR_VIEWED: 'interview_pillar_viewed',
  INTERVIEW_SETUP_ABANDONED: 'interview_setup_abandoned',
  INTERVIEW_SETUP_CONFIG_COMPLETED: 'interview_setup_config_completed',
  INTERVIEW_SETUP_CV_UPLOADED: 'interview_setup_cv_uploaded',
  INTERVIEW_SETUP_JD_PASTED: 'interview_setup_jd_pasted',
  INTERVIEW_SETUP_LOADING_CANCELLED: 'interview_setup_loading_cancelled',
  INTERVIEW_SETUP_LOADING_FAILED: 'interview_setup_loading_failed',
  INTERVIEW_SETUP_LOADING_STARTED: 'interview_setup_loading_started',
  INTERVIEW_SETUP_SUBMITTED: 'interview_setup_submitted',
  INTERVIEW_SETUP_VIEWED: 'interview_setup_viewed',
  INTERVIEW_STARTED: 'interview_started',
  INTERVIEW_RECONNECT_ATTEMPTED: 'interview_reconnect_attempted',
  INTERVIEW_RECONNECT_SUCCEEDED: 'interview_reconnect_succeeded',
  INTERVIEW_RECONNECT_FAILED: 'interview_reconnect_failed',
  INTERVIEW_RECONNECT_EXHAUSTED: 'interview_reconnect_exhausted',
  INTERVIEW_RECONNECT_READY_TIMEOUT: 'interview_reconnect_ready_timeout',
  INTERVIEW_WS_CLOSED: 'interview_ws_closed',
  INTERVIEW_TRANSCRIPT_TOGGLED: 'interview_transcript_toggled',
  INTERVIEW_TRANSCRIPT_VIEWED: 'interview_transcript_viewed',
  INTERVIEW_WARNING_TOAST_SHOWN: 'interview_warning_toast_shown',
  JD_PARSING_FAILED: 'jd_parsing_failed',
  LOGIN_ATTEMPTED: 'login_attempted',
  LOGIN_COMPLETED: 'login_completed',
  LOGIN_FAILED: 'login_failed',
  LOGIN_PAGE_VIEWED: 'login_page_viewed',
  LOGOUT_COMPLETED: 'logout_completed',
  ONBOARDING_VIDEO_COMPLETED: 'onboarding_video_completed',
  ONBOARDING_VIDEO_SKIPPED: 'onboarding_video_skipped',
  ONBOARDING_VIDEO_STARTED: 'onboarding_video_started',
  PAGE_LOAD_SLOW: 'page_load_slow',
  PASSWORD_CHANGED: 'password_changed',
  PASSWORD_RESET_COMPLETED: 'password_reset_completed',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  PAYMENT_CANCELLED: 'payment_cancelled',
  PAYMENT_COMPLETED: 'payment_completed',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_STARTED: 'payment_started',
  NOTIFICATION_SETTING_CHANGED: 'notification_setting_changed',
  PRIVACY_SETTING_CHANGED: 'privacy_setting_changed',
  PROFILE_CV_UPLOADED: 'profile_cv_uploaded',
  PROFILE_PAGE_VIEWED: 'profile_page_viewed',
  PROFILE_UPDATED: 'profile_updated',
  QUOTA_LIMIT_REACHED: 'quota_limit_reached',
  SESSION_ENDED: 'session_ended',
  SESSION_STARTED: 'session_started',
  SIGNUP_ABANDONED: 'signup_abandoned',
  SIGNUP_COMPLETED: 'signup_completed',
  SIGNUP_EMAIL_SUBMITTED: 'signup_email_submitted',
  SIGNUP_GOOGLE_INITIATED: 'signup_google_initiated',
  SIGNUP_METHOD_SELECTED: 'signup_method_selected',
  SIGNUP_PAGE_VIEWED: 'signup_page_viewed',
  SIGNUP_VERIFICATION_COMPLETED: 'signup_verification_completed',
  SIGNUP_VERIFICATION_FAILED: 'signup_verification_failed',
  SIGNUP_VERIFICATION_RESENT: 'signup_verification_resent',
  SIGNUP_VERIFICATION_SENT: 'signup_verification_sent',
  SUBSCRIPTION_BILLING_CYCLE_TOGGLED: 'subscription_billing_cycle_toggled',
  SUBSCRIPTION_PAGE_VIEWED: 'subscription_page_viewed',
  TIMEOUT_OCCURRED: 'timeout_occurred',
  UPGRADE_BUTTON_CLICKED: 'upgrade_button_clicked',
  UPGRADE_CONFIRMED: 'upgrade_confirmed',
  UPGRADE_MODAL_CLOSED: 'upgrade_modal_closed',
  UPGRADE_MODAL_VIEWED: 'upgrade_modal_viewed',
  UPGRADE_PROMPT_CLICKED: 'upgrade_prompt_clicked',
  UPGRADE_PROMPT_DISMISSED: 'upgrade_prompt_dismissed',
  UPGRADE_PROMPT_DISPLAYED: 'upgrade_prompt_displayed',
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];
